import { Component, OnInit } from '@angular/core';
// import { MatTableDataSource } from '@angular/material';
import * as ObjectUtils from 'util';
import { SiteStepperEnum } from 'src/app/shared';
import { SiteService, SiteStepperService } from 'src/app/services/index';
import { SiteModel, SiteStepperModel } from 'src/app/models/index';
import { AssignMeterModalComponent } from './assign-meter-modal/assign-meter-modal.component';
import { MatDialog } from '@angular/material';
import { AlertService, Constants, DateService } from 'src/app/shared/index';
@Component({
  selector: 'app-data-acquisition-layout',
  templateUrl: './data-acquisition-layout.component.html',
  styleUrls: ['./data-acquisition-layout.component.scss']
})
export class DataAcquisitionLayoutComponent implements OnInit {
  siteId: string;
  siteModel: SiteModel;
  processes: any;
  // dataSource: MatTableDataSource<any>;
  dacData = [];
  displayedColumns = ['loadName', 'loadId', 'Location', 'meterId', 'insiteMeterID',
    'dcuID', 'ctMake', 'ctRatingPrimary', 'ctAccuracy'];
  constructor(private siteStepperService: SiteStepperService, private siteService: SiteService,
    public dialog: MatDialog, private alertService: AlertService) { }

  ngOnInit() {
    this.siteStepperService.getStepperSubject().subscribe(data => {
      if (data.selectedIndex === SiteStepperEnum.DataAcquisitionLayout && !ObjectUtils.isNullOrUndefined(data.siteModel)) {
        this.siteId = data.siteModel.siteId;
        this.siteModel = data.siteModel;
        this.getProcessAndLoadsData();
      }
    });

  }
  private getProcessAndLoadsData = () => {
    this.siteService.getProcessAndLoadsBySiteId(this.siteId, true).subscribe(data => {
      this.processes = data;
    });
  }

  public previousStep = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(new SiteStepperModel(SiteStepperEnum.ReportConfiguration, this.siteModel));
  }
  nextStep = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(new SiteStepperModel(SiteStepperEnum.TreeConfiguration, this.siteModel));
  }
  submitDACFrom() {
    const t = this;
    t.siteService.saveDACDetail(t.dacData).subscribe(data => {
      if (data.result === Constants.SUCCESS) {
        t.alertService.showSuccess(Constants.MESSAGE.Save_success);
      } else {
        t.alertService.showError(data.message);
      }
    });
  }

  openAssignMeterModal(load) {
    const t = this;
    if (load) {

      t.siteService.getAvailableMeterForLoad().subscribe(meters => {
        if (meters.length > 0) {
          const dialogRef = this.dialog.open(AssignMeterModalComponent, {
            width: '50%',
            data: { selectedLoad: load, availableMeters: meters, siteId: this.siteId }
          });
          // dialogRef.componentInstance.selectedLoad = load;
          // dialogRef.componentInstance.availableMeters = meters;
          // dialogRef.componentInstance.siteId = this.siteId;

          dialogRef.afterClosed().subscribe(result => {
            if (result.status === true) {
              this.dacData = result.data;
            }
          });
        }

      });

    }
  }
}
